module.exports = __webpack_public_path__ + "static/assets/681994a7b229e8390f9ae5e94312ea1a.png";